// Copy for the "editing this activity stops the stage automation" confirm.
//
// Six surfaces show this warning (interview-plan interview/assessment/coding
// -assessment editors, the candidate-drawer assessment + coding-assessment, and
// the ScheduleInterview scorecard edit). Keeping the strings here is what stops
// them drifting apart again — they previously ran across three different modal
// components with four different CTA labels.

// The activity the user is editing — interpolated into both title and body.
export type AutomationStopActivity = 'interview' | 'assessment';

// Whose automation stops. The interview-plan editors are stage-level surfaces
// ("this stage's automation"); the candidate drawer and ScheduleInterview act on
// one application ("the stage automation for this candidate").
export type AutomationStopScope = 'stage' | 'candidate';

// Confirming re-runs the save AND stops the automation, so the CTA is the
// neutral "Confirm" rather than a save-framed verb.
export const AUTOMATION_STOP_CONFIRM_CTA = 'Confirm';
export const AUTOMATION_STOP_CANCEL_CTA = 'Cancel';

// Save-framed header — the user pressed Save, this confirms that save.
export const getAutomationStopTitle = (
  activity: AutomationStopActivity
): string => `Save ${activity}?`;

export const getAutomationStopBody = (
  activity: AutomationStopActivity,
  scope: AutomationStopScope
): string =>
  scope === 'candidate'
    ? `Changes made to the ${activity} affect the stage automation for this candidate. The automation will be stopped.`
    : `Changes made to the ${activity} affect this stage’s automation. The automation will be stopped.`;
